import ProductContainer from '@app/Pjax/ProductContainer'
import ProductTrigger from '@app/Pjax/ProductTrigger'

export default function install(Vue) {
  Vue.component(ProductContainer.name, ProductContainer)
  Vue.component(ProductTrigger.name, ProductTrigger)
}
